import type { Boucle, MaillonDeBoucle } from '../../partage/api/types';

/**
 * Le tour de la boucle, dans l'ordre du dessin du refus (`RefusDeCycle`) : chaque maillon
 * attend le suivant, et le dernier attend le premier par la condition tentée, celle qu'on
 * dessine en pointillé.
 *
 * Le chemin rendu par le serveur se referme sur lui-même : on retire le doublon final, puis
 * on **fait tourner** la liste pour que la condition tentée soit toujours le dernier pas. Le
 * pointillé tombe ainsi au même endroit quel que soit l'ordre où le serveur a trouvé la boucle.
 *
 * `tente` a la même forme pour un lien et pour un déplacement (chantier `deplacer`, ticket 01) :
 * `cibleId` attendrait `sourceId`. Pour un déplacement, `sourceId` est la bulle qu'on range et
 * `cibleId` sa nouvelle place : le dernier maillon est la bulle d'arrivée, qui attendrait ce
 * qu'on y range.
 */
export function tourDeBoucle(boucle: Boucle): MaillonDeBoucle[] {
  const maillons = boucle.boucle.slice(0, -1);
  if (maillons.length < 2) return maillons;

  const k = maillons.findIndex(
    (m, i) =>
      m.id === boucle.tente.cibleId &&
      maillons[(i + 1) % maillons.length]?.id === boucle.tente.sourceId
  );
  if (k < 0) return maillons;

  return [...maillons.slice(k + 1), ...maillons.slice(0, k + 1)];
}
